(function () {
  if (customElements.get('image-banner-carousel-po')) return;

  class ImageBannerCarouselPo extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.image-banner-carousel-po__track');
      if (!this.track) return;

      this.realSlides = Array.from(this.track.children);
      if (this.realSlides.length < 2) return;

      this.prevButton = this.querySelector('[name="previous"]');
      this.nextButton = this.querySelector('[name="next"]');

      this.firstClone = this.realSlides[0].cloneNode(true);
      this.lastClone = this.realSlides[this.realSlides.length - 1].cloneNode(true);
      [this.firstClone, this.lastClone].forEach((clone) => {
        clone.setAttribute('aria-hidden', 'true');
        clone.setAttribute('tabindex', '-1');
        clone.querySelectorAll('a, button, input, select, textarea').forEach((el) => {
          el.setAttribute('tabindex', '-1');
        });
        clone.querySelectorAll('[id]').forEach((el) => el.removeAttribute('id'));
        if (clone.hasAttribute('id')) clone.removeAttribute('id');
      });

      this.track.appendChild(this.firstClone);
      this.track.insertBefore(this.lastClone, this.realSlides[0]);

      this.slides = Array.from(this.track.children);
      this.currentIndex = 1;
      this.isAnimating = false;
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      this.setPosition(false);
      this.updateSlideVisibility();

      if (this.nextButton) this.nextButton.addEventListener('click', () => this.go(1));
      if (this.prevButton) this.prevButton.addEventListener('click', () => this.go(-1));

      this.track.addEventListener('transitionend', (event) => {
        if (event.target === this.track) this.onTransitionEnd();
      });

      this.track.style.touchAction = 'pan-y';
      this.track.addEventListener('pointerdown', this.onPointerDown.bind(this));

      const autoplay = this.track.dataset.autoplay === 'true';
      if (autoplay) {
        this.autoplaySpeed = (parseFloat(this.track.dataset.speed) || 5) * 1000;
        this.addEventListener('mouseenter', () => this.pause());
        this.addEventListener('mouseleave', () => this.play());
        this.addEventListener('focusin', () => this.pause());
        this.addEventListener('focusout', () => this.play());
        this.play();
      }
    }

    play() {
      if (this.reducedMotion || !this.autoplaySpeed) return;
      this.pause();
      this.autoplayTimer = setInterval(() => this.go(1), this.autoplaySpeed);
    }

    pause() {
      clearInterval(this.autoplayTimer);
    }

    go(direction) {
      if (this.isAnimating) return;
      this.isAnimating = true;
      this.currentIndex += direction;
      this.setPosition(true);
    }

    setPosition(animate) {
      this.track.classList.toggle('image-banner-carousel-po__track--animate', animate);
      this.track.style.transform = 'translateX(-' + this.currentIndex * 100 + '%)';
      if (!animate) this.isAnimating = false;
    }

    onTransitionEnd() {
      const lastRealIndex = this.slides.length - 2;
      if (this.currentIndex === this.slides.length - 1) {
        this.currentIndex = 1;
        this.setPosition(false);
      } else if (this.currentIndex === 0) {
        this.currentIndex = lastRealIndex;
        this.setPosition(false);
      }
      this.isAnimating = false;
      this.updateSlideVisibility();
    }

    updateSlideVisibility() {
      this.slides.forEach((slide, index) => {
        if (slide === this.firstClone || slide === this.lastClone) return;
        const isActive = index === this.currentIndex;
        slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
        slide.querySelectorAll('a, button').forEach((el) => {
          if (isActive) el.removeAttribute('tabindex');
          else el.setAttribute('tabindex', '-1');
        });
      });
    }

    onPointerDown(event) {
      if (this.isAnimating) return;
      const dragStartX = event.clientX;
      const onUp = (upEvent) => {
        window.removeEventListener('pointerup', onUp);
        const deltaX = upEvent.clientX - dragStartX;
        const threshold = this.getBoundingClientRect().width * 0.15;
        if (deltaX > threshold) this.go(-1);
        else if (deltaX < -threshold) this.go(1);
      };
      window.addEventListener('pointerup', onUp);
    }

    goToSlide(descendantElement) {
      let target = descendantElement;
      while (target && target.parentElement !== this.track) {
        target = target.parentElement;
      }
      if (!target) return;
      const index = this.slides.indexOf(target);
      if (index === -1 || index === this.currentIndex) return;
      this.isAnimating = true;
      this.currentIndex = index;
      this.setPosition(true);
    }
  }

  customElements.define('image-banner-carousel-po', ImageBannerCarouselPo);

  document.addEventListener('shopify:block:select', function (event) {
    const slide = event.target.closest('.image-banner-carousel-po__slide');
    if (!slide) return;
    const carousel = slide.closest('image-banner-carousel-po');
    if (!carousel) return;
    carousel.pause();
    carousel.goToSlide(slide);
  });

  document.addEventListener('shopify:block:deselect', function (event) {
    const slide = event.target.closest('.image-banner-carousel-po__slide');
    if (!slide) return;
    const carousel = slide.closest('image-banner-carousel-po');
    if (!carousel) return;
    carousel.play();
  });
})();
